import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import SearchIcon from './icons/SearchIcon';

export default function SearchField({
  placeholder,
  value,
  onChange,
  id,
  className,
  dataTestId
}) {
  const { t } = useTranslation();
  function handleChange(e) {
    const {
      target: { value },
    } = e;

    onChange(value);
  }
  return (
    (<div
      data-testid={dataTestId}
      className={classNames('relative z-0', className)}>
      <div data-testid="div-e60056ba" className="w-full max-w-xs">
        <label data-testid="label-9b51fd68" htmlFor="search" className="sr-only">
          {t('SEARCH')}
        </label>
        <div data-testid="div-c0a0ba5a" className="relative">
          <div
            data-testid="div-58bf4d98"
            className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <SearchIcon
              className="h-5 w-5 flex-shrink-0 text-gray-400"
              aria-hidden="true"
            />
          </div>
          <input
            data-testid="searchFieldInput"
            id={id}
            className="block w-full py-2 pl-10 pr-3 placeholder-gray-500 bg-white border border-gray-300 rounded-md leading-5 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo sm:text-sm transition duration-150 ease-in-out focus:border-green-cm focus:ring-green-cm"
            placeholder={placeholder}
            type="search"
            value={value}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>)
  );
}

SearchField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  id: PropTypes.string,
};

SearchField.defaultProps = {
  placeholder: 'Search...',
};
